import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {instanceOf} from 'prop-types'
import {withCookies, Cookies} from 'react-cookie'

class CookieMonster extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    }

    constructor(props) {
        super(props)

        const {cookies} = props
        this.state = {
            cookiemonster: cookies.get('COOKIEMONSTER') || 'COOKIEMONSTER',
            showCookieMonster: true,
        }
    }

    componentDidMount() {
        this.checkCookies()
    }

    setCookies = () => {
        const d = new Date()
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000)
        this.props.cookies.set('COOKIEMONSTER', 2, {path: '/', expires: d})
        this.setState(prevState => ({showCookieMonster: !prevState.showCookieMonster}))
    }

    checkCookies = () => {
        if (this.state.cookiemonster === '2') {
            this.setState(prevState => ({showCookieMonster: !prevState.showCookieMonster}))
        } else {
            const d = new Date()
            d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000)
            this.props.cookies.set('COOKIEMONSTER', 1, {path: '/', expires: d})
        }
    }

    render() {
        const showCookies = this.state.showCookieMonster ? ' ' : 'hide-cookie-monster'

        return (
            <div className={['cookie-monster', showCookies].join(' ')}>
                <div className="row">
                    <div className="col-sm-12 col-lg-3">
                        <h5>Piškotki na spletnem mestu</h5>
                    </div>
                    <div className="col-sm12 col-lg-7">
                        <span>
                            Spletna stran uporablja piškotke s pomočjo katerih izboljšuje vašo
                            uporabniško izkušnjo, analizira promet ter omogoča uporabo vtičnikov
                            družbenih medijev. Z nadaljno uporabo se strinjate k uporabi piškotkov.
                            Več o tem si lahko preberete <Link to="/piskotki/">tukaj</Link>.
                        </span>
                    </div>
                    <div className="col-sm-12 col-lg-2">
                        <button onClick={this.setCookies}>Sprejmem</button>
                    </div>
                </div>
            </div>
        )
    }
}

export default withCookies(CookieMonster)



// WEBPACK FOOTER //
// ./src/components/CookieMonster.js